import styled from 'styled-components/macro';

const StyledEditor = styled.div`
    position: relative;

    flex: 1 0 auto;
`;

export default StyledEditor;
